// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1rCrm","bigColWidth":"Table_bigColWidth__2b6ir","biggerColWidth":"Table_biggerColWidth__3faQ7","row":"Table_row__oJYeG","col":"Table_col__2_z8L"};